// extracted by mini-css-extract-plugin
export var imageModalContainer = "index-module--imageModalContainer--6452b";
export var imageModalDialog = "index-module--imageModalDialog--2b905";
export var imageModalHeader = "index-module--imageModalHeader--80c78";
export var imageWrapper = "index-module--imageWrapper--f62ed";